import { useState } from 'react';

export default function ChatInput({ onSend, selectedUser, onOpenDrawer }) {
  const [text, setText] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  // 🔎 Heuristic: เดสก์ท็อป vs มือถือ/แท็บเล็ต
  const isLikelyDesktop = () => {
    if (typeof window === 'undefined') return true;
    const ua = navigator.userAgent || navigator.vendor || '';
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPadOS 13+ รายงานเป็น Mac
    const isAndroid = /Android/.test(ua);
    const isCoarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
    const isMobileOrTablet = isIOS || isAndroid || isCoarse || hasTouch;
    return !isMobileOrTablet;
  };

  const sendToLine = async (message) => {
    const userId = selectedUser?.lineId || selectedUser?.userId;
    if (!userId) {
      console.warn('⛔️ ไม่มี userId จาก selectedUser');
      return;
    }

    try {
      const res = await fetch('https://therefineryclinic.herokuapp.com/sendToLine', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, message }),
      });

      const result = await res.json();
      if (!result.success) {
        console.error('❌ ส่ง LINE ไม่สำเร็จ:', result.error);
      } else {
        console.log('✅ ส่ง LINE สำเร็จ:', result);
      }
    } catch (err) {
      console.error('❌ เกิดข้อผิดพลาด:', err);
    }
  };

  const handleConfirmSend = () => {
    onSend(text);
    sendToLine(text);
    setText('');
    setShowConfirm(false);
  };

  const handleSubmit = () => {
    if (!text.trim()) return;
    setShowConfirm(true);
  };

  // ⌨️ พฤติกรรมคีย์:
  // - Desktop: Enter (เดี่ยว) = ส่ง (เปิดกล่องยืนยัน), Shift+Enter = ขึ้นบรรทัดใหม่
  // - iPad/Tablet/มือถือ: Enter = ขึ้นบรรทัดใหม่เสมอ
  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') return;

    // ถ้ากดพร้อมตัวช่วย ให้คงพฤติกรรมเดิม (เช่น Shift+Enter = newline)
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return;

    if (isLikelyDesktop()) {
      e.preventDefault();
      handleSubmit();
    }
    // มือถือ/แท็บเล็ต: ไม่ขัดขวาง ให้ Enter เป็น newline ตามค่าเริ่มต้นของ <textarea>
  };

  return (
    <>
      <div className="border-t px-4 py-3 bg-white">
        <div className="flex gap-2">
          <textarea
            rows={1}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Type your reply..."
            className="flex-1 text-sm px-4 py-3 bg-white border border-gray-300 rounded-md resize-none"
            style={{
              minHeight: '80px',
              maxHeight: 'calc(75vh - 233px)',
              overflow: 'auto',
              boxShadow: 'none',
              outline: 'none',
            }}
          />
          <div className="flex flex-col justify-between items-center gap-2 pb-1">
            <button
              onClick={onOpenDrawer}
              className="w-10 h-10 bg-gray-100 rounded-full text-gray-700 flex items-center justify-center hover:bg-gray-200"
              aria-label="Open attachments and templates"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
              </svg>
            </button>
            <button
              onClick={handleSubmit}
              className="text-white text-sm font-semibold px-4 h-[40px] bg-green-500 hover:bg-green-600 border-none rounded-md"
              style={{ minWidth: '48px', boxShadow: 'none' }}
            >
              Send
            </button>
          </div>
        </div>
      </div>

      {showConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-sm rounded-md shadow-xl p-6">
            <h2 className="text-base font-semibold mb-4">Confirm to Send ?</h2>
            <p className="text-gray-700 mb-6 whitespace-pre-wrap">{text}</p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded-md text-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmSend}
                className="px-4 py-2 text-sm bg-green-500 hover:bg-green-600 text-white rounded-md"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
